(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    if (window.location.search.includes('contact_posted=true')) {
    // Anker aus der URL entfernen, damit der Browser nicht dorthin springt
    history.replaceState(null, '', window.location.pathname + window.location.search);
    // nach ganz oben scrollen
    window.scrollTo(0, 0);
  }
  } catch(e) { console.error(e); }
})();

})();
